<template>
  <div ref="confirmEl" @touchstart.passive.stop @mousedown.stop>
    <core-modal-header>
      <span>{{ heading }}</span>
    </core-modal-header>

    <core-modal-body>
      <div
        v-if="warning"
        class="flex items-start gap-4 rounded-lg border-l-4 border-amber-500 bg-amber-100 px-5 py-5 sm:gap-5 sm:px-6"
      >
        <u-icon
          :name="warning.icon || COMMON_ICONS.alert"
          class="mt-1 h-10 w-10 shrink-0 text-amber-500 sm:h-12 sm:w-12"
        />

        <div class="min-w-0 flex-1">
          <p class="text-lg font-normal text-slate-800">
            <template v-for="(part, index) in warning.titleParts" :key="index">
              <span :class="{'font-bold': part.emphasized}">{{ part.text }}</span>
            </template>
          </p>
          <p class="mt-2 text-sm text-slate-600">
            {{ warning.description }}
          </p>
        </div>
      </div>

      <p
        v-if="message"
        :class="warning ? 'mt-4 text-base text-slate-500' : null"
      >
        {{ message }}
      </p>
    </core-modal-body>

    <core-modal-footer>
      <u-button v-if="!nonCancelable" size="xl" color="charcoal" variant="soft" @click="modal.close()">Cancel</u-button>
      <u-button size="xl" :color="color" @click="confirm" :loading="isSaving">{{confirmText}}</u-button>
    </core-modal-footer>
  </div>
</template>

<script setup>
  const props = defineProps({
    color: String,
    heading: String,
    message: String,
    warning: Object,
    confirmMethod: Function,
    modal: Object,
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    nonCancelable: Boolean
  });

  const emit = defineEmits(['on-confirm']);

  const isSaving = ref(false);
  async function confirm() {
    try {
      isSaving.value = true;
      await props.confirmMethod();
      emit('on-confirm');
      props.modal.close();
    } finally {
      isSaving.value = false;
    }
  }

  const confirmEl = ref();

  onMounted(() => {
    /*confirmEl.value.addEventListener('click', e => {
      e.stopPropagation();
    }, true);*/
  });
</script>
